// Paleta oficial del Re-Branding Gráfico Reuse V5 (colores primarios + secundarios de uso digital).
export const REUSE_COLORS = {
  foundationPurple: '#151930',
  solidPurple: '#37417f',
  risingLilac: '#afb9ff',
  accentGreen: '#c6ffad',
  reBlue: '#4b75f7',
  boldBlue: '#272eff',
  fizzyGreen: '#bafe6a',
  white: '#ffffff'
}

export const withAlpha = (hex: string, alpha: number): string => {
  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return `rgba(${r}, ${g}, ${b}, ${alpha})`
}

// Mismo criterio que los badges "calidad"/"open box" del brandbook: fondo tintado del color de marca
// y texto siempre foundationPurple. Usar el color de marca como texto (en vez de foundationPurple) se
// ve ilegible/chillón con los tonos claros (accentGreen, risingLilac, fizzyGreen), así que se evita.
export const badgeStyle = (bgHex: string, alpha = 0.35, textHex: string = REUSE_COLORS.foundationPurple): { backgroundColor: string, color: string } => ({
  backgroundColor: withAlpha(bgHex, alpha),
  color: textHex
})
